import { render, staticRenderFns } from "./k-admin-release.vue?vue&type=template&id=021b4992&lang=pug&"
import script from "./k-admin-release.vue?vue&type=script&lang=js&"
export * from "./k-admin-release.vue?vue&type=script&lang=js&"
import style0 from "./k-admin-release.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('021b4992')) {
      api.createRecord('021b4992', component.options)
    } else {
      api.reload('021b4992', component.options)
    }
    module.hot.accept("./k-admin-release.vue?vue&type=template&id=021b4992&lang=pug&", function () {
      api.rerender('021b4992', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/blocks/k-admin-release.vue"
export default component.exports